const aaa = [

    //欠宠记录
    {
        path: "arrearsOrderList",
        component: () => import("@/views/dingdan/order/arrearsOrder/list.vue"),
        meta: { title: '订单', keepAlive: false },
    },
    {
        path: "arrearsOrderSee",
        component: () => import("@/views/dingdan/order/arrearsOrder/see.vue"),
        meta: { title: '订单' },
    },
 
   
    
]
export default aaa;